export const zaloRoutingMessages = {
  vi: {
    zaloRouting: {
      menuLabel: 'Điều phối Zalo',
      title: 'Quản lý điều phối Zalo',
      subtitle: 'Quản lý danh sách tuyển dụng viên nhận lượt truy cập Zalo.',
      listTitle: 'Nhân viên nhận lượt quét',
      listHint: 'Người đang nhận được chia từ mã tổng. Mã khu vực chỉ chia cho nhân viên gắn với mã đó.',
      points: {
        title: 'Mã theo khu vực',
        hint: 'Mỗi mã gắn với một khu. Công nhân quét được chia luân phiên cho nhân viên của mã đó, rồi mở trang thêm Zalo của người được chọn.',
        cardHint: 'Chia luân phiên cho {names}.',
        add: 'Thêm mã QR',
        code: 'Mã QR',
        codeHint: 'Ví dụ GEE-YP-01, GEE-QC-01',
        area: 'Khu vực',
        recruiters: 'Nhân viên nhận',
        owners: 'Nhân viên phụ trách',
        viewQr: 'Xem QR',
        recruiterHint: 'Có thể gắn nhiều người, thường 5 người cho một mã.',
        empty: 'Chưa có mã QR khu vực.',
        scansToday: 'Quét hôm nay',
        scansTotal: 'Tổng quét',
        enabled: 'Đang dùng',
        disabled: 'Đã tắt',
        save: 'Lưu mã QR',
        edit: 'Sửa mã',
        remove: 'Xóa mã',
        removeConfirm: 'Xóa mã QR {code}? Mã đã in sẽ không còn chuyển tới Zalo.',
        saved: 'Đã lưu mã QR khu vực.',
        removed: 'Đã xóa mã QR.',
        loadFailed: 'Không tải được danh sách mã QR.',
        saveFailed: 'Không lưu được mã QR.',
      },
      publicUrl: 'Mã tổng',
      publicUrlHint: 'Đặt mã này ở mọi khu. Quét xong chia cho nhân viên đang nhận, nhưng không biết công nhân đứng ở khu nào.',
      publicQrAlt: 'Mã QR tổng',
      qrMark: 'GEE',
      copyPublicUrl: 'Sao chép URL',
      copySuccess: 'Đã sao chép URL Zalo.',
      copyFallback:
        'Không truy cập được clipboard. URL đã được chọn, hãy sao chép thủ công.',
      actions: {
        add: 'Thêm zalo nhân sự',
        import: 'Import',
        downloadCsv: 'Tải mẫu CSV',
        downloadXlsx: 'Tải mẫu XLSX',
        downloadQr: 'Tải ảnh QR',
        edit: 'Sửa',
        enable: 'Bật',
        disable: 'Tắt',
        retry: 'Thử lại',
        close: 'Đóng',
        cancel: 'Hủy',
        save: 'Lưu',
        saving: 'Đang lưu…',
        importing: 'Đang import…',
      },
      kpis: {
        totalRecruiters: 'Nhân viên nhận',
        activeRecruiters: 'Đang nhận',
        inactiveRecruiters: 'Không nhận',
        scansToday: 'Lượt quét hôm nay',
        scansTotal: 'Tổng lượt quét',
        ariaLabel: 'Chỉ số điều phối Zalo',
      },
      scans: {
        view: 'Xem chi tiết',
        todayTitle: 'Lượt quét hôm nay',
        allTitle: 'Tổng lượt quét',
        area: 'Khu vực',
        count: 'Lượt quét',
        unknown: 'Chưa xác định',
        empty: 'Chưa có lượt quét.',
        emptyRecruiters: 'Chưa có nhân viên nhận.',
        loadFailed: 'Không tải được danh sách lượt quét.',
        loadFailedRecruiters: 'Không tải được danh sách nhân viên.',
      },
      filters: {
        search: 'Tìm kiếm',
        searchPlaceholder: 'Tên hoặc số điện thoại',
        status: 'Trạng thái',
        all: 'Tất cả',
        active: 'Đang nhận',
        disabled: 'Ngừng nhận',
        blocked: 'Không chia được',
      },
      table: {
        name: 'Tên',
        hrLinked: 'Đã liên kết HR',
        phone: 'Số điện thoại',
        resolvedUrl: 'URL Zalo',
        missingDestination: 'Chưa có đích đến',
        status: 'Trạng thái',
        receives: 'Khu vực',
        overallCode: 'Mã tổng',
        assignmentsToday: 'Lượt nhận hôm nay',
        assignmentsTotal: 'Tổng lượt nhận',
        overallScans: 'Chưa xác định khu vực',
        areaScans: 'Theo khu vực',
        scansToday: 'Hôm nay',
        scansAllTime: 'Tổng',
        lastAssignedAt: 'Lần nhận gần nhất',
        actions: 'Thao tác',
        neverAssigned: 'Chưa nhận',
        emptyInitial: 'Chưa có recruiter nào.',
        emptyFiltered: 'Không có recruiter phù hợp bộ lọc.',
      },
      status: {
        active: 'Đang nhận',
        disabled: 'Ngừng nhận',
        blocked: 'Không chia được',
      },
      blockedReasons: {
        missing_destination: 'Thiếu URL hoặc số điện thoại hợp lệ',
        employee_inactive: 'Nhân sự không hoạt động',
        employee_resigned: 'Nhân sự đã nghỉ việc',
        employee_suspended: 'Nhân sự bị đình chỉ',
        employee_deleted: 'Hồ sơ nhân sự đã bị xóa',
      },
      form: {
        createTitle: 'Thêm recruiter Zalo',
        editTitle: 'Cập nhật recruiter Zalo',
        linkedWarning:
          'Tên và số điện thoại sẽ đồng thời cập nhật hồ sơ Employee đã liên kết.',
        name: 'Tên',
        phone: 'Số điện thoại',
        zaloUrl: 'URL Zalo tùy chỉnh',
        enabled: 'Tham gia điều phối',
        notes: 'Ghi chú',
      },
      import: {
        title: 'Import recruiter Zalo',
        description: 'Hỗ trợ CSV, TXT, XLSX; dung lượng tối đa 5 MB.',
        file: 'File dữ liệu',
        selectFile: 'Chọn file',
        selectedFile: 'Đã chọn: {name}',
        submit: 'Import dữ liệu',
        resultTitle: 'Kết quả import',
        total: 'Tổng dòng',
        created: 'Đã tạo',
        updated: 'Đã cập nhật',
        autoLinked: 'Tự liên kết HR',
        errorsTitle: 'Lỗi theo dòng',
        row: 'Dòng',
        field: 'Trường',
        message: 'Chi tiết',
        completed: 'Import hoàn tất.',
      },
      confirmations: {
        enable: 'Bật điều phối cho {name}?',
        disable: 'Tắt điều phối cho {name}?',
        enableTitle: 'Xác nhận bật recruiter',
        disableTitle: 'Xác nhận tắt recruiter',
      },
      validation: {
        required: 'Trường này là bắt buộc.',
        too_long: 'Giá trị vượt quá độ dài cho phép.',
        invalid_phone: 'Số điện thoại không hợp lệ.',
        invalid_url: 'URL phải dùng HTTPS và thuộc zalo.me.',
        missing_destination:
          'Recruiter đang bật phải có URL hoặc số điện thoại hợp lệ.',
        unsupported_type: 'Chỉ chấp nhận file CSV, TXT hoặc XLSX.',
        too_large: 'File không được vượt quá 5 MB.',
      },
      errors: {
        loadSummary: 'Không tải được chỉ số tổng quan.',
        loadList: 'Không tải được danh sách recruiter.',
        save: 'Không lưu được recruiter.',
        toggle: 'Không cập nhật được trạng thái recruiter.',
        import: 'Không import được dữ liệu.',
        download: 'Không tải được file mẫu.',
        qrDownload: 'Không tải được ảnh QR.',
        recordMissing:
          'Recruiter không còn tồn tại. Danh sách đã được làm mới.',
        rateLimited: 'Thao tác quá nhanh. Vui lòng thử lại sau {seconds} giây.',
        generic: 'Đã xảy ra lỗi. Vui lòng thử lại.',
      },
      success: {
        created: 'Đã thêm recruiter.',
        updated: 'Đã cập nhật recruiter.',
        enabled: 'Đã bật recruiter.',
        disabled: 'Đã tắt recruiter.',
        downloaded: 'Đã tải file mẫu.',
        qrDownloaded: 'Đã tải ảnh QR.',
      },
    },
  },
  en: {
    zaloRouting: {
      menuLabel: 'Zalo routing',
      title: 'Zalo routing management',
      subtitle: 'Manage recruiters who receive Zalo traffic.',
      listTitle: 'Recruiters receiving scans',
      listHint: 'People who are receiving get scans from the overall code. An area code only reaches the recruiters linked to it.',
      points: {
        title: 'Area codes',
        hint: 'Each code belongs to one area. A scan is handed to that code’s recruiters in turn, then opens the chosen recruiter’s Zalo add page.',
        cardHint: 'Handed in turn to {names}.',
        add: 'Add QR code',
        code: 'QR code',
        codeHint: 'Example GEE-YP-01, GEE-QC-01',
        area: 'Area',
        recruiters: 'Receiving recruiters',
        owners: 'Responsible recruiters',
        viewQr: 'View QR',
        recruiterHint: 'A code can link several people, often five.',
        empty: 'No area QR codes yet.',
        scansToday: 'Scans today',
        scansTotal: 'Total scans',
        enabled: 'Active',
        disabled: 'Off',
        save: 'Save QR code',
        edit: 'Edit code',
        remove: 'Delete code',
        removeConfirm: 'Delete QR {code}? Printed copies will stop opening Zalo.',
        saved: 'Area QR saved.',
        removed: 'QR code deleted.',
        loadFailed: 'Could not load area QR codes.',
        saveFailed: 'Could not save the QR code.',
      },
      publicUrl: 'Overall code',
      publicUrlHint: 'Place this code in every area. A scan is handed to an active recruiter, without recording which area it came from.',
      publicQrAlt: 'Overall QR code',
      qrMark: 'GEE',
      copyPublicUrl: 'Copy URL',
      copySuccess: 'Zalo URL copied.',
      copyFallback:
        'Clipboard is unavailable. The URL is selected; copy it manually.',
      actions: {
        add: 'Add Zalo staff',
        import: 'Import',
        downloadCsv: 'Download CSV template',
        downloadXlsx: 'Download XLSX template',
        downloadQr: 'Download QR image',
        edit: 'Edit',
        enable: 'Enable',
        disable: 'Disable',
        retry: 'Retry',
        close: 'Close',
        cancel: 'Cancel',
        save: 'Save',
        saving: 'Saving…',
        importing: 'Importing…',
      },
      kpis: {
        totalRecruiters: 'Receiving staff',
        activeRecruiters: 'Receiving',
        inactiveRecruiters: 'Not receiving',
        scansToday: 'Scans today',
        scansTotal: 'Total scans',
        ariaLabel: 'Zalo routing metrics',
      },
      scans: {
        view: 'View details',
        todayTitle: 'Scans today',
        allTitle: 'All scans',
        area: 'Area',
        count: 'Scans',
        unknown: 'Unknown area',
        empty: 'No scans yet.',
        emptyRecruiters: 'No receiving recruiters yet.',
        loadFailed: 'Could not load scans.',
        loadFailedRecruiters: 'Could not load recruiters.',
      },
      filters: {
        search: 'Search',
        searchPlaceholder: 'Name or phone number',
        status: 'Status',
        all: 'All',
        active: 'Receiving',
        disabled: 'Not receiving',
        blocked: 'Cannot receive',
      },
      table: {
        name: 'Name',
        hrLinked: 'HR linked',
        phone: 'Phone',
        resolvedUrl: 'Zalo URL',
        missingDestination: 'No destination',
        status: 'Status',
        receives: 'Area',
        overallCode: 'Overall code',
        assignmentsToday: 'Received today',
        assignmentsTotal: 'Total received',
        overallScans: 'Area unknown',
        areaScans: 'By area',
        scansToday: 'Today',
        scansAllTime: 'Total',
        lastAssignedAt: 'Last received',
        actions: 'Actions',
        neverAssigned: 'None yet',
        emptyInitial: 'No recruiters yet.',
        emptyFiltered: 'No recruiters match the filters.',
      },
      status: { active: 'Receiving', disabled: 'Not receiving', blocked: 'Cannot receive' },
      blockedReasons: {
        missing_destination: 'Missing a valid URL or phone number',
        employee_inactive: 'Employee is inactive',
        employee_resigned: 'Employee has resigned',
        employee_suspended: 'Employee is suspended',
        employee_deleted: 'Employee record was deleted',
      },
      form: {
        createTitle: 'Add Zalo recruiter',
        editTitle: 'Update Zalo recruiter',
        linkedWarning:
          'Name and phone changes will also update the linked Employee record.',
        name: 'Name',
        phone: 'Phone',
        zaloUrl: 'Custom Zalo URL',
        enabled: 'Include in routing',
        notes: 'Notes',
      },
      import: {
        title: 'Import Zalo recruiters',
        description: 'Supports CSV, TXT and XLSX up to 5 MB.',
        file: 'Data file',
        selectFile: 'Choose file',
        selectedFile: 'Selected: {name}',
        submit: 'Import data',
        resultTitle: 'Import result',
        total: 'Total rows',
        created: 'Created',
        updated: 'Updated',
        autoLinked: 'Auto-linked to HR',
        errorsTitle: 'Row errors',
        row: 'Row',
        field: 'Field',
        message: 'Details',
        completed: 'Import completed.',
      },
      confirmations: {
        enable: 'Enable routing for {name}?',
        disable: 'Disable routing for {name}?',
        enableTitle: 'Confirm recruiter enable',
        disableTitle: 'Confirm recruiter disable',
      },
      validation: {
        required: 'This field is required.',
        too_long: 'The value exceeds the allowed length.',
        invalid_phone: 'The phone number is invalid.',
        invalid_url: 'The URL must use HTTPS and belong to zalo.me.',
        missing_destination:
          'An enabled recruiter needs a valid URL or phone number.',
        unsupported_type: 'Only CSV, TXT or XLSX files are accepted.',
        too_large: 'The file must not exceed 5 MB.',
      },
      errors: {
        loadSummary: 'Could not load summary metrics.',
        loadList: 'Could not load recruiters.',
        save: 'Could not save the recruiter.',
        toggle: 'Could not update recruiter status.',
        import: 'Could not import data.',
        download: 'Could not download the template.',
        qrDownload: 'Could not download the QR image.',
        recordMissing:
          'The recruiter no longer exists. The list has been refreshed.',
        rateLimited: 'Too many requests. Try again in {seconds} seconds.',
        generic: 'Something went wrong. Please try again.',
      },
      success: {
        created: 'Recruiter added.',
        updated: 'Recruiter updated.',
        enabled: 'Recruiter enabled.',
        disabled: 'Recruiter disabled.',
        downloaded: 'Template downloaded.',
        qrDownloaded: 'QR image downloaded.',
      },
    },
  },
  zh: {
    zaloRouting: {
      menuLabel: 'Zalo 分流',
      title: 'Zalo 分流管理',
      subtitle: '管理接收 Zalo 访问流量的招聘人员。',
      listTitle: '接收扫码的招聘员',
      listHint: '正在接收的人会从总码分到扫码。分区码只分给绑定在该码上的招聘员。',
      points: {
        title: '分区码',
        hint: '每个码对应一个区域。扫码后按顺序分给该码绑定的招聘员，并打开该招聘员的 Zalo 添加页。',
        cardHint: '按顺序分给 {names}。',
        add: '添加二维码',
        code: '二维码',
        codeHint: '例如 GEE-YP-01、GEE-QC-01',
        area: '区域',
        recruiters: '接待招聘员',
        owners: '负责招聘员',
        viewQr: '查看二维码',
        recruiterHint: '一个码可绑定多人，通常为 5 人。',
        empty: '还没有分区二维码。',
        scansToday: '今日扫码',
        scansTotal: '累计扫码',
        enabled: '启用',
        disabled: '停用',
        save: '保存二维码',
        edit: '编辑',
        remove: '删除',
        removeConfirm: '删除二维码 {code}？已印刷的码将不再打开 Zalo。',
        saved: '已保存分区二维码。',
        removed: '已删除二维码。',
        loadFailed: '无法加载分区二维码。',
        saveFailed: '无法保存二维码。',
      },
      publicUrl: '总码',
      publicUrlHint: '此码放在所有区域。扫码会分给在岗招聘员，但无法记录来自哪个区域。',
      publicQrAlt: '总二维码',
      qrMark: 'GEE',
      copyPublicUrl: '复制 URL',
      copySuccess: '已复制 Zalo URL。',
      copyFallback: '无法访问剪贴板。URL 已选中，请手动复制。',
      actions: {
        add: '添加 Zalo 人员',
        import: '导入',
        downloadCsv: '下载 CSV 模板',
        downloadXlsx: '下载 XLSX 模板',
        downloadQr: '下载二维码图片',
        edit: '编辑',
        enable: '启用',
        disable: '停用',
        retry: '重试',
        close: '关闭',
        cancel: '取消',
        save: '保存',
        saving: '保存中…',
        importing: '导入中…',
      },
      kpis: {
        totalRecruiters: '接收人员',
        activeRecruiters: '正在接收',
        inactiveRecruiters: '未接收',
        scansToday: '今日扫码',
        scansTotal: '累计扫码',
        ariaLabel: 'Zalo 分流指标',
      },
      scans: {
        view: '查看明细',
        todayTitle: '今日扫码',
        allTitle: '全部扫码',
        area: '区域',
        count: '扫码次数',
        unknown: '未确定区域',
        empty: '还没有扫码记录。',
        emptyRecruiters: '还没有接待招聘员。',
        loadFailed: '无法加载扫码记录。',
        loadFailedRecruiters: '无法加载招聘员列表。',
      },
      filters: {
        search: '搜索',
        searchPlaceholder: '姓名或电话号码',
        status: '状态',
        all: '全部',
        active: '正在接收',
        disabled: '停止接收',
        blocked: '无法分配',
      },
      table: {
        name: '姓名',
        hrLinked: '已关联 HR',
        phone: '电话号码',
        resolvedUrl: 'Zalo URL',
        missingDestination: '缺少目标地址',
        status: '状态',
        receives: '区域',
        overallCode: '总码',
        assignmentsToday: '今日接到',
        assignmentsTotal: '累计接到',
        overallScans: '未确定区域',
        areaScans: '按区域',
        scansToday: '今日',
        scansAllTime: '总计',
        lastAssignedAt: '最近接到',
        actions: '操作',
        neverAssigned: '尚未接到',
        emptyInitial: '暂无招聘人员。',
        emptyFiltered: '没有符合筛选条件的招聘人员。',
      },
      status: { active: '正在接收', disabled: '停止接收', blocked: '无法分配' },
      blockedReasons: {
        missing_destination: '缺少有效 URL 或电话号码',
        employee_inactive: '员工未启用',
        employee_resigned: '员工已离职',
        employee_suspended: '员工已停职',
        employee_deleted: '员工档案已删除',
      },
      form: {
        createTitle: '添加 Zalo 招聘人员',
        editTitle: '更新 Zalo 招聘人员',
        linkedWarning: '姓名和电话号码也会同步更新已关联的 Employee 档案。',
        name: '姓名',
        phone: '电话号码',
        zaloUrl: '自定义 Zalo URL',
        enabled: '参与分流',
        notes: '备注',
      },
      import: {
        title: '导入 Zalo 招聘人员',
        description: '支持 CSV、TXT、XLSX，最大 5 MB。',
        file: '数据文件',
        selectFile: '选择文件',
        selectedFile: '已选择：{name}',
        submit: '导入数据',
        resultTitle: '导入结果',
        total: '总行数',
        created: '已创建',
        updated: '已更新',
        autoLinked: '自动关联 HR',
        errorsTitle: '行错误',
        row: '行',
        field: '字段',
        message: '详情',
        completed: '导入完成。',
      },
      confirmations: {
        enable: '启用 {name} 的分流？',
        disable: '停用 {name} 的分流？',
        enableTitle: '确认启用招聘人员',
        disableTitle: '确认停用招聘人员',
      },
      validation: {
        required: '此字段为必填项。',
        too_long: '内容超过允许长度。',
        invalid_phone: '电话号码无效。',
        invalid_url: 'URL 必须使用 HTTPS 且属于 zalo.me。',
        missing_destination: '启用的招聘人员必须有有效 URL 或电话号码。',
        unsupported_type: '仅接受 CSV、TXT 或 XLSX 文件。',
        too_large: '文件不能超过 5 MB。',
      },
      errors: {
        loadSummary: '无法加载汇总指标。',
        loadList: '无法加载招聘人员列表。',
        save: '无法保存招聘人员。',
        toggle: '无法更新招聘人员状态。',
        import: '无法导入数据。',
        download: '无法下载模板。',
        qrDownload: '无法下载二维码图片。',
        recordMissing: '该招聘人员已不存在，列表已刷新。',
        rateLimited: '操作过于频繁，请在 {seconds} 秒后重试。',
        generic: '发生错误，请重试。',
      },
      success: {
        created: '已添加招聘人员。',
        updated: '已更新招聘人员。',
        enabled: '已启用招聘人员。',
        disabled: '已停用招聘人员。',
        downloaded: '模板已下载。',
        qrDownloaded: '二维码图片已下载。',
      },
    },
  },
}
